import { environment as prodEnvironment } from './environment.prod';

export const environment = {
  ...prodEnvironment,
  textbookApiUrl: 'https://preview-multipodreczniki.apps.gwo.pl/api',
  editorPreviewMode: true,
};
